module.exports = __webpack_public_path__ + "img/zxyfw-2.36ce02fa.jpg";